import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

export const Careers = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen pt-16" style={{fontFamily:'IBM Plex Sans,sans-serif'}}>
      <SEO
        title={`${t('careers.title')} | Durable Designs`}
        description={t('careers.p1')}
        path="/people/careers"
      />

      <section className="bg-green-900 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <Link
            to="/engineering/people"
            className="inline-flex items-center gap-2 text-sm text-green-200 hover:text-white transition-colors mb-8"
            data-testid="back-to-people"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('careers.back')}
          </Link>
          <h1
            className="text-4xl sm:text-5xl font-semibold text-white tracking-tight"
            style={{fontFamily:'Outfit,sans-serif'}}
            data-testid="careers-heading"
          >
            {t('careers.title')}
          </h1>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <p className="text-base text-gray-600 leading-relaxed mb-4">
              {t('careers.p1')}
            </p>
            <p className="text-base text-gray-600 leading-relaxed mb-10">
              {t('careers.p2')}
            </p>

            <Link
              to="/engineering/contact"
              className="inline-flex items-center gap-2 bg-green-700 hover:bg-green-800 text-white px-6 py-3 text-sm font-medium tracking-wide transition-colors"
              data-testid="speculative-application-cta"
            >
              {t('careers.cta')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
